import {
  StepChecklistItem,
  StepChecklistItemState,
} from '@varo/graphql-schema-types';
import React from 'react';
import { StyleSheet, View } from 'react-native';
import { StepProps } from 'shared/components/vxl/ProgressIndicator/StepChecklist/base/Step/Step';
import StepChecklist from 'shared/components/vxl/ProgressIndicator/StepChecklist/StepChecklist';
import BodySmText from 'shared/components/vxl/typography/primary/body/BodySmText';
import theme from 'shared/styles/theme';

interface Props {
  steps: StepChecklistItem[];
}

const DirectDepositChecklist = ({ steps }: Props) => {
  const stepperStates: StepProps[] = steps.map((step) => {
    const isComplete = step.state === StepChecklistItemState.Complete;

    return {
      id: step.id,
      stepState: step.state.toLowerCase() as StepProps['stepState'],
      indicator: {
        icon: step.icon,
        tintColor: theme.color.interactive.primary,
      },
      content: {
        descriptionText: step.descriptionText,
        annotation: step.annotationText ? (
          <BodySmText
            style={
              isComplete
                ? styles.annotationComplete
                : styles.annotationIncomplete
            }
          >
            {step.annotationText}
          </BodySmText>
        ) : undefined,
      },
    };
  });

  return (
    <View style={styles.wrapper}>
      <StepChecklist stepperHeading="" stepperStates={stepperStates} />
    </View>
  );
};

const styles = StyleSheet.create({
  annotationComplete: {
    color: theme.color.interactive.primary,
  },
  annotationIncomplete: {
    color: theme.color.text.secondary,
  },
  wrapper: {
    backgroundColor: theme.color.background.primary,
    borderColor: theme.color.border.primarySolid,
    borderRadius: theme.spacing.xs,
    borderWidth: 1,
    marginBottom: theme.spacing.m,
    marginHorizontal: theme.spacing.m,
    marginTop: theme.spacing.s,
  },
});

export default DirectDepositChecklist;
